import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "@/shared/libs/axiosClient";
import { queryClient, queryKeys } from "@/shared/libs/queryClient";
import { toast } from "@/shared/hooks/useToast";

interface GetSlackChannelResponse {
  channel: string | null;
}

interface UpdateSlackChannelRequest {
  channel: string;
}

async function fetchChannel(): Promise<GetSlackChannelResponse> {
  return api.get<GetSlackChannelResponse>("/monthly-performance-slack");
}

async function updateChannel(channel: string): Promise<void> {
  const request: UpdateSlackChannelRequest = { channel };
  return api.put<void>("/monthly-performance-slack", request);
}

export function useMonthlyPerformanceSlackChannelQuery() {
  return useQuery({
    queryKey: queryKeys.monthlyPerformanceSlack.channel(),
    queryFn: fetchChannel,
  });
}

export function useUpdateMonthlyPerformanceSlackChannelMutation() {
  return useMutation({
    mutationFn: updateChannel,
    onSuccess: () => {
      toast({ title: "저장되었습니다." });
      queryClient.invalidateQueries({ queryKey: queryKeys.monthlyPerformanceSlack.channel() });
    },
    onError: (error: Error) => {
      toast({
        title: "저장 실패",
        description: error.message,
        variant: "destructive",
      });
    },
  });
}
